import { useEffect } from 'react';
import { assert } from '@chainflip/utils/assertion';
import useEvmScAccount from '@/shared/hooks/useEvmScAccount';
import useEvmScCall from '@/shared/hooks/useEvmScCall';
import useToast from '@/shared/hooks/useToast';
import { FLIP_SYMBOL } from '@/shared/utils/env';
import { getViemError } from '@/shared/utils/functions';
import type TokenAmount from '@/shared/utils/TokenAmount';

export default function useUndelegateFlip({ onSuccess }: { onSuccess?: () => void } = {}) {
  const { delegationSDK: sdk } = useEvmScAccount();
  const evmToast = useToast('evm-delegate-flip');
  const scToast = useToast('sc-delegate-flip');

  useEffect(
    () => () => {
      evmToast.dismiss();
      scToast.dismiss();
    },
    [],
  );

  return useEvmScCall({
    fn: (amount: TokenAmount | undefined) => {
      assert(sdk, 'Delegation SDK not initialized');

      evmToast.loading('Submitting call to Ethereum...');

      return sdk.undelegate(amount);
    },
    onSubmitted: ({ args: amount }) => {
      evmToast.success(
        `Successfully submitted call to undelegate ${amount?.toFormatted()} ${FLIP_SYMBOL} tokens`,
      );
      scToast.loading('Waiting for confirmation of undelegation on the State Chain...');
    },
    onEvmError: (err) => evmToast.error('Undelegation failed', { description: getViemError(err) }),
    onScError: (err) => {
      scToast.error('Undelegation failed on the State Chain', { description: err.name });
    },
    onSuccess: () => {
      onSuccess?.();
      scToast.success('Undelegation confirmed on the State Chain!');
    },
  });
}
